import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import ImageGallery from "./ImageGallery";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import FilterBar from "./FilterBar";
import SelectFilterBar from "./SelectFilterBar";

import SERVER_ADDRESS from "../../../../config";
import { EditGoujianImageDialogButton } from "../../utils";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  divider: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.light
  },
  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "100%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}));

//使用图片内容过滤
function useFilter(initValue) {
  const [filterValue, setFilterValue] = useState(initValue);

  const handleChange = name => event => {
    setFilterValue({ ...filterValue, [name]: event.target.value });
  };

  return { filterValue, handleChange };
}

const objectArrayFilter = (objectArray, filterValue) => {
  const filterFields = Object.keys(filterValue);
  let objectFiltered = [...objectArray];
  for (let index = 0; index < filterFields.length; index++) {
    const filterField = filterFields[index];

    if (filterValue[filterField] !== "" && objectFiltered.length > 0) {
      objectFiltered = objectFiltered.filter(object => {
        return object[filterField].indexOf(filterValue[filterField]) !== -1;
      });
    }
  }
  return objectFiltered;
};

function useGoujianImages(initValue, fetchUrl, goujianId) {
  const [images, setImages] = useState(initValue);
  useEffect(() => {
    async function getGoujianImages() {
      const imgs = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include"
      }).then(res => {
        return res.json();
      });

      setImages(imgs);
    }
    getGoujianImages();
  }, [goujianId]);

  //freshData
  const freshData = (data, method, deleteId) => {
    if (method === "update") {
      setImages((prevImages, props) => {
        const newImages = [];
        prevImages.forEach(image => {
          newImages.push(image.id === data.id ? data : image);
        });
        return newImages;
      });
    }
    if (method === "delete") {
      setImages((prevImages, props) => {
        const newImages = [];
        prevImages.forEach(image => {
          if (image.id !== deleteId) {
            newImages.push(image);
          }
        });
        return newImages;
      });
    }
    if (method === "add") {
      setImages([...images, data]);
    }
  };
  return { images, freshData };
}

function GoujianImages(props) {
  const classes = useStyles();
  const categoryOptions = ["图纸", "照片"];

  const { goujianId, goujian } = props;
  let graphQuery = `${SERVER_ADDRESS}/api/goujianimages/?goujian__id=${goujianId}`;
  // let photoQuery = `${SERVER_ADDRESS}/api/goujianimages/?goujian__id=${goujianId}&category=照片`;
  //图纸Gallery
  const { images: graphImages, freshData } = useGoujianImages(
    [],
    graphQuery,
    goujianId
  );

  //过滤图纸State
  const {
    filterValue: graphfilterValue,
    handleChange: handleGraphFilterChange
  } = useFilter({
    description: "",
    architecture: "",
    user_nickname: "",
    category: ""
  });

  let graphToRender = objectArrayFilter(graphImages, graphfilterValue);

  return (
    <>
      <Grid container className={classes.paper} component={Paper} spacing={1}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            gutterBottom
            color="secondary"
            className={classes.typography}
          >
            图纸照片
            {Object.keys(goujian).length > 0 ? (
              <EditGoujianImageDialogButton
                goujian={goujian}
                freshData={data => {
                  freshData(data, "add");
                }}
                buttonText={`新增${goujian.name}图纸`}
                add
              />
            ) : null}
          </Typography>
          {graphImages.length > 1 ? (
            <>
              <FilterBar
                value={graphfilterValue.description}
                handleChange={handleGraphFilterChange("description")}
                label="过滤图片描述"
              />
              <FilterBar
                value={graphfilterValue.architecture}
                handleChange={handleGraphFilterChange("architecture")}
                label="过滤建筑出处"
              />
              <FilterBar
                value={graphfilterValue.user_nickname}
                handleChange={handleGraphFilterChange("user_nickname")}
                label="过滤上传人"
              />
              <SelectFilterBar
                categoryOptions={categoryOptions}
                value={graphfilterValue.category}
                handleChange={handleGraphFilterChange("category")}
                label="图片类型"
                minWidth="200px"
              />
            </>
          ) : null}

          <Divider variant="fullWidth" className={classes.divider} light />
        </Grid>

        <Grid item xs={12}>
          <ImageGallery images={graphToRender} freshData={freshData} />
        </Grid>
      </Grid>
    </>
  );
}

export default GoujianImages;
